import React, { useState, useEffect } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Avatar, Divider, Fab, TableHead, alpha } from '@mui/material';
import { getShopingNow, sellDeletedMat } from '../../services/material-services';
import PaginationControlled from './mat-pagination';
import { useAuth } from '../../hooks/useAuth';
import { useLocation } from 'react-router-dom';
import {NotificationManager} from 'react-notifications';
import BackspaceIcon from '@mui/icons-material/Backspace';
import AskDialogDelete from './mat-ask-del';



function ShoppingTable() {
    const { authData } = useAuth();
    const location = useLocation();
    const { state } = location;

    const [rows, setRows] = useState('');
    const [materials, setMaterials] = useState(null);
    const [error, setError] = useState(false);
    const [loading, setLoding] = useState(false);
    const [searchFact, setSearchFact] = useState('');
    
    const [page, setPage] = useState(1);
    const [totalPage, setTotalPage] = useState(1);
    const [showPagin, setShowPagin] = useState(false);    // const [summary, setSummary] = useState(0);
    const numRows = 10;
    
    const [open, setOpen] = useState(false);
    const [summary, setSummary] = useState(0);



    useEffect(()=>{
      if (state !== null){
        setSearchFact(`&factors=${state}`);
      }else{
        setSearchFact('&req_final=false');
      }
      // console.log('state', searchFact)

        setLoding(true);
        const getData = async() =>{
          await getShopingNow(authData.token, page, numRows, searchFact)
            .then(data => {
                if (data?.results.length > 0){
                  setMaterials(data?.results[0]?.sell_mat_groups);
                }
                
                const totalPTranc = Math.trunc(data.count / numRows);
                const totalP = data.count / numRows;
                
                setTotalPage(totalPTranc);
                if((totalPTranc < totalP) & (totalPage > 1)){
                  setTotalPage(totalPTranc + 1);
                  setShowPagin(true);
                }
                
                if(totalPage > 1){
                  setShowPagin(true);
                }

                setLoding(false);
                if (data?.results.length > 0){
                    const result = data?.results[0]?.sell_mat_groups?.reduce((total, currentValue) => total = total + (currentValue.sell_count * currentValue.sell_money),0);
                    setSummary(result);
                }
                
            }).catch( e => {
                setError(true);
                setLoding(false);
            })
        }
        getData();
        // console.log("materials", materials)
      
    }, [])
    
    const handlePegani = (value) => {
        setPage(value);
        if (state !== null){
            setSearchFact(`&factors=${state}`);
        }else{
            setSearchFact('&req_final=false');
        }

        setLoding(true);
        const getData = async() =>{
        await getShopingNow(authData.token, value, numRows, searchFact)
        .then(data => {

            if (data?.results.length > 0){
              setMaterials(data?.results[0]?.sell_mat_groups);
            }

            // console.log(data)

            const totalPTranc = Math.trunc(data.count / numRows);
            const totalP = data.count / numRows;
            // console.log(data);
            // console.log(numRows, totalP, totalPTranc, data.count);
            
            setTotalPage(totalPTranc);
            if(totalPTranc < totalP){
              setTotalPage(totalPTranc + 1);
              setShowPagin(true);
            }
            
            if(totalPage > 1){
              setShowPagin(true);
            }

            setLoding(false);
            if (data?.results.length > 0){
                const result = data?.results[0].sell_mat_groups?.reduce((total, currentValue) => total = total + (currentValue.sell_count * currentValue.sell_money),0);
                setSummary(result);
            }

        }).catch( e => {
            setError(true);
            setLoding(false);
        })
        }
        getData();

    }
    // const [selectedValue, setSelectedValue] = useState('');


    const handleClose = (value) => {
        setOpen(false);
        // setSelectedValue(value);
        // console.log(value);
        setLoding(true);
        
        
        const getData = async() =>{
          await sellDeletedMat(authData.token, {'sell_id' : value.id})
          .then(data => {
            
              setMaterials((current) =>
                  current.filter((materials) => materials.id !== value.id));
              // console.log(data)
              NotificationManager.success(value.name + 'از سبد خرید شما حذف شد', 'حذف :');
          }).catch( e => {
                setError(true);
                setLoding(false);
                NotificationManager.error('متاسفانه خطایی در زمان حذف محصول وجود دارد');
          })
        }
        getData();
    };
  
    const handleCLick = (value) => {
        // console.log(value);
        setOpen(true);
        setRows(value);
    };

   

  return (
    <React.Fragment>
      <div>
          <AskDialogDelete 
              onClose={handleClose} 
              selectedValue={rows}
              open={open}/>
        
        <TableContainer component={Paper}>
          <Table aria-label="custom pagination table">
            <TableHead>
                <TableRow  sx={{fontFamily: 'b_mitra'}}>
                    <TableCell colSpan={3} sx={{ fontFamily: 'b_mitra', textAlign: 'center'}} component="th" scope="row">
                        <h1>نام کالا</h1>
                    </TableCell>
                    <TableCell style={{ fontFamily: 'b_mitra', textAlign: 'center'}} component="th" scope="row">
                        <h1>تعداد</h1>
                    </TableCell>
                    <TableCell style={{ fontFamily: 'b_mitra', textAlign: 'center'}} component="th" scope="row">
                        <h1>قیمت</h1>
                    </TableCell>
                    <TableCell style={{ fontFamily: 'b_mitra', textAlign: 'center'}} component="th" scope="row">
                        <h1>جمع</h1>
                    </TableCell>

                </TableRow>
            </TableHead>
            <TableBody >
              {materials?.map((row) => (
                <TableRow key={row.name} sx={{fontFamily: 'b_mitra'}}>
                  {/* <Link to={'/shopping'} state={row.bio} style={{ color: 'blue'}}>{row.bio}</Link> */}
                  <TableCell component="th" scope="row" >
                      <Fab variant="extended"  size="small" 
                          color="primary" aria-label="add"
                          onClick={() => handleCLick(row)}
                        >
                          <BackspaceIcon sx={{ mr: 1 }} />
                      </Fab>
                  </TableCell>
                  <TableCell component="th" scope="row" >
                      <Avatar alt={row.material?.alt_image} src={'http://localhost:8000' + row.material?.image} />
                  </TableCell>
                  <TableCell style={{ fontFamily: 'b_mitra'}} component="th" scope="row">
                      <h2>{row.material?.name}</h2>
                  </TableCell>
                  <TableCell style={{ fontFamily: 'b_mitra', textAlign: 'center' }} align="right">
                      <h3>{row.sell_count}</h3>
                  </TableCell>
                  <TableCell style={{ fontFamily: 'b_mitra', textAlign: 'center' }} align="right">
                    <h3>{row.sell_money} ریال</h3>
                  </TableCell>
                  <TableCell style={{ fontFamily: 'b_mitra', textAlign: 'center'}} align="right">
                    <h2><b>{row.sell_count * row.sell_money}</b> ریال</h2>
                  </TableCell>
                </TableRow>
              ))}
              {/* {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )} */}
              <TableRow sx={{ width:'100%', fontFamily: 'b_mitra', background: alpha('#7b1fa2', 0.15)}}>
                
                <TableCell colSpan={3} 
                    style={{ 
                      fontFamily: 'b_mitra', 
                      textAlign: 'center' }} component="th" scope="row">
                    <h2>جمع کل:</h2>
                </TableCell>
                <TableCell colSpan={3} style={{  fontFamily: 'b_mitra', textAlign: 'left'}} align="right">
                    <h2><b>{summary}</b> ریال</h2>
                </TableCell>
              </TableRow>

            </TableBody>
          </Table>
        </TableContainer>
        <br/>
        <Divider />
        <br/>
        {showPagin &&
            <div style={{width: '100%', display: 'block', textAlign: 'center'}}>
                <PaginationControlled onChange={handlePegani} pageNow={page} totalCount={totalPage}/>
            </div>
        }            
      </div>
    </React.Fragment>
  );
}

export default ShoppingTable;
